// User-defined Interactive templates slice.
//
// Authors can save the current scene's InteractivePlugin items + section
// workflow triggers as a reusable template (saveSceneAsTemplateThunk in
// common/actions.es6). The resulting payload mirrors the seed JSON shape
// in plugins/InteractivePlugin/templates so applyTemplateThunk can consume
// user templates and seed templates symmetrically.
//
// Lives OUTSIDE undoGroup — saving a template is a meta action, not a
// document edit, and it shouldn't pollute undo/redo. localStorage is the
// persistence backup so user templates survive reloads even without
// middleware support (see LOAD_USER_TEMPLATES_FROM_STORAGE).
import {
  ADD_USER_TEMPLATE,
  REMOVE_USER_TEMPLATE,
  LOAD_USER_TEMPLATES_FROM_STORAGE,
} from "../common/actions";

const initialState = [];

export default function userTemplates(state = initialState, action = {}) {
  switch (action.type) {
    case ADD_USER_TEMPLATE: {
      const tpl = action.payload && action.payload.template;
      if (!tpl || typeof tpl !== "object" || !tpl.id) return state;
      // Replace if an entry with the same id already exists, so re-saving
      // under the same id behaves like an upsert rather than producing
      // duplicates.
      const filtered = state.filter((t) => t.id !== tpl.id);
      return [...filtered, tpl];
    }
    case REMOVE_USER_TEMPLATE: {
      const id = action.payload && action.payload.id;
      if (!id) return state;
      return state.filter((t) => t.id !== id);
    }
    case LOAD_USER_TEMPLATES_FROM_STORAGE: {
      const list = action.payload && action.payload.templates;
      if (!Array.isArray(list)) return state;
      // Filter to only well-formed entries (id + items + triggers arrays).
      return list.filter(
        (t) =>
          t &&
          typeof t === "object" &&
          typeof t.id === "string" &&
          Array.isArray(t.items) &&
          Array.isArray(t.triggers)
      );
    }
    default:
      return state;
  }
}
